<template>
  <TwoColPageWrapper
    class="video-page"
    :menuItems="videoLinks"
    :breadcrumbs="breadcrumbs"
    leftBanner
  >
    <v-fade-transition>
      <div :key="$route.path">
        <h1>{{ title }}</h1>
        <div v-html="curVideoItem.desc"></div>
        <div class="b-video">
          <div
            v-for="(video, index) in curVideoItem.items"
            :key="index"
            class="b-video__element"
          >
            <div class="b-video__title">
              {{ video.label }}
            </div>
            <div class="b-video__iframe">
              <iframe
                width="100%"
                height="240"
                :src="video.url"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </v-fade-transition>
  </TwoColPageWrapper>
</template>

<script>
import { mapState } from "vuex";
export default {
  created() {
    this.init();
  },
  data() {
    return {
      id: -1,
      videos: {
        1: {
          items: [
            {
              label: "Укладка паркета по системе Sika® AcouBond",
              url: "https://www.youtube.com/embed/5OvDcAY9czg",
            },
            {
              label: "Создание террасы с использованием материалов Sika®",
              url: "https://www.youtube.com/embed/27KKo8n8Zv0",
            },
            {
              label: "Выравнивание пола с использованием материалов Sika®",
              url: "https://www.youtube.com/embed/Sq5D_r12_JA",
            },
            {
              label: "Как получить надежный и ровный пол в гараже за три дня?",
              url: "https://www.youtube.com/embed/egp_q4OZs3c",
            },
          ],
        },
        2: {
          items: [
            {
              label: "Видео применения Sikaflex® Crystal Clear",
              url: "https://www.youtube.com/embed/UhufPi99zJA",
            },
            {
              label: "Видео применения Sanisil® / Sikasil -C",
              url: "https://www.youtube.com/embed/IogwwZzG9l8",
            },
            {
              label: "Как использовать Sikaflex®-11 FC +?",
              url: "https://www.youtube.com/embed/vIaTWV8HtgE",
            },
            {
              label:
                "Sikaflex® AT-Connection - теплоизоляция окон или как уменьшить потерю тепла на 40%",
              url: "https://www.youtube.com/embed/JgE-8TC6PqU",
            },
            {
              label:
                "Как герметизировать швы, стыки и примыкания? Использование SikaFlex® Precast",
              url: "https://www.youtube.com/embed/1HUYWdA4sik",
            },
            {
              label:
                "Как герметезировать деформационный шов? Используем Sikaflex® Construction+",
              url: "https://www.youtube.com/embed/AdkTIzIHTj8",
            },
          ],
        },
        3: {
          items: [
            {
              label: "Sika® MultiSeal",
              url: "https://www.youtube.com/embed/Tad3rg_7axA",
            },
            {
              label: "Применение материалов Sika для гидроизоляции",
              url: "https://www.youtube.com/embed/1wrqVqqbdGE",
            },
            {
              label: "Видео применения Sika® BlackSeal®-1",
              url: "https://www.youtube.com/embed/7oSHYSZY4tI",
            },
            {
              label: "Эффективная отсечка капиллярной влаги в кирпичной кладке",
              url: "https://www.youtube.com/embed/rl4TKX0W1T0",
            },
          ],
        },
        4: {
          items: [
            {
              label: "Эпоксидный клей Sikadur®-31 CF Normal",
              url: "https://www.youtube.com/embed/Op_5mLvRROU",
            },
            {
              label:
                "Sikaflex® AT-Connection - теплоизоляция окон или как уменьшить потерю тепла на 40%",
              url: "https://www.youtube.com/embed/JgE-8TC6PqU",
            },
            {
              label: "Эффективная отсечка капиллярной влаги в кирпичной кладке",
              url: "https://www.youtube.com/embed/rl4TKX0W1T0",
            },
          ],
        },
        5: {
          items: [
            {
              label: "Видео применения SikaCem® Color",
              url: "https://www.youtube.com/embed/3DXO23YNZtk",
            },
            {
              label:
                "Добавка для повышения эластичности растворов, устройства тонких стяжек и адгезионных слоёв SikaLatex",
              url: "https://www.youtube.com/embed/-jntNfEe4S4",
            },
            {
              label: "Применение пластификаторов Sika® для раствора бетона",
              url: "https://www.youtube.com/embed/VsLedtf9DWA",
            },
            {
              label: "Sikament® BV 3M",
              url: "https://www.youtube.com/embed/yyW2oFuTfTg",
            },
            {
              label: "Sika® Antifreеze N9",
              url: "https://www.youtube.com/embed/ustZq9LVHAA",
            },
            {
              label:
                "Приготовление цементного раствора для штукатурки — что добавлять и какие пропорции?",
              url: "https://www.youtube.com/embed/qEtmFYtmJ3w",
            },
            {
              label:
                "Изготовление раствора для кирпичной кладки с использованием добавок Sika®",
              url: "https://www.youtube.com/embed/X4IIGB8DCUU",
            },
          ],
        },
        6: {
          items: [
            {
              label: "Sikadur®-31 CF Rapid",
              url: "https://www.youtube.com/embed/Op_5mLvRROU",
            },
          ],
        },
        7: {
          desc: `<p>
	 В «Академии FORUMHOUSE» вышел новый обучающий курс компании Sika. В этот раз технологи и тренеры концерна рассказали о добавках. Из видео и статей курса вы узнаете об основных характеристиках бетонных смесей и цементных растворов, подходах к приобретению готовых решений и самостоятельному изготовлению смесей и растворов на строительной площадке.
</p>
<p>
	 Пройдя курс, вы получите информацию о том, как при помощи добавок Sika можно улучшить качественные характеристики бетона, штукатурки, кирпичной кладки и напольной стяжки. По окончании обучения вы можете сдать тест и получить сертификат, который станет дополнительным свидетельством вашей компетенции в данной тематике.
</p>
<p>
 <a href="https://www.forumhouse.ru/academy/courses/15" target="_blanc" rel="nofollow">Полный курс</a>
</p>`,
          items: [
            {
              label:
                "Бетон и бетонные смеси. Учимся выбирать и делать самостоятельно.",
              url: "https://www.youtube.com/embed/ekSKUDTa1RY",
            },
            {
              label: "Бетонные смеси для фундаментных работ. Что важно знать.",
              url: "https://www.youtube.com/embed/5tQclAJxNFY",
            },
            {
              label:
                "Кладка облицовочного кирпича. Технология и выбор раствора.",
              url: "https://www.youtube.com/embed/4kBQA29HLUg",
            },
            {
              label: "Устройство напольной стяжки методом «мокрый по мокрому».",
              url: "https://www.youtube.com/embed/QlRsKOydzeY",
            },
            {
              label: "Штукатурные работы методом «мокрый по мокрому».",
              url: "https://www.youtube.com/embed/XOF71f82OFU",
            },
            {
              label: "Изготавливаем тротуарную плитку самостоятельно.",
              url: "https://www.youtube.com/embed/m40j9eFbcW8",
            },
          ],
        },
      },
    };
  },
  methods: {
    init() {
      this.id = parseInt(this.$route.params.id);
    },
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: "Главная",
          to: { name: "main" },
        },
        {
          label: "Видео",
        },
        {
          label: this.title,
        },
      ];
    },
    title() {
      const menuItem = this.videoLinks.find(
        (item) => item.to.params.id === this.id
      );
      return menuItem && menuItem.label;
    },
    curVideoItem() {
      this.init();
      return this.videos[this.id];
    },
    ...mapState(["videoLinks"]),
  },
};
</script>

<style lang="scss" scoped></style>
